export default __webpack_public_path__ + "static/media/smileTwo.34a3dae5.svg";